export default __webpack_public_path__ + "static/media/icon_mydata_completed.c0c4c51c.svg";